import { EventEmitter, Injectable, Output } from '@angular/core';
import { Observable } from 'rxjs';
import { LoginRequest } from '../models/request/login.request';
import { BaseResponse } from '../models/response/BaseResponse';
import { HttpService } from './http.service';
import {User} from '../models/User';

@Injectable({
  providedIn: 'root'
})
export class AuthService extends HttpService{

  @Output() userlogin = new EventEmitter<User>();

  isUserLogged(): boolean{
    return !!localStorage.getItem('token');
  }

  login(username: string, password: string): Observable<BaseResponse<User>>{
    return this.post('login', new LoginRequest(username, password));
  }

  logout(): void{
    this.get('logout').subscribe(
      result => {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
      }
    );
  }

  getUser(): User{
    return JSON.parse(localStorage.getItem('user') as string);
  }

  // public hasRole(roleString: string): boolean{
  //   // @ts-ignore
  //   return this.getUser().roles?.filter(role => (role.code === roleString)).length > 0;
  // }

  // public isActive(): boolean{
  //   return this.getUser().is_active ?? false;
  // }

}
